/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { EWidgetStatus } from '../widgetTypes';
import { TWidgetCostsChartValue } from './types/widgetCostsType';
import { IWidgetCostsChart, IWidgetCostsReducer } from './widgetCostsReducer';

export const selectWidgetCosts = (state: IRootReducer): IWidgetCostsReducer => state.dashboard.widgetCosts;

export const makeSelectorWidgetCostsChart = ():
    OutputSelector<IRootReducer, IWidgetCostsChart, (state: IWidgetCostsReducer) => IWidgetCostsChart> =>
    createSelector(
        selectWidgetCosts,
        (state: IWidgetCostsReducer) => state.charts,
    );

export const makeSelectorWidgetCostsCurrentChart = (dateTo: string):
    OutputSelector<IRootReducer, TWidgetCostsChartValue | undefined, (state: IWidgetCostsReducer) =>
        TWidgetCostsChartValue> =>
    createSelector(
        selectWidgetCosts,
        (state: IWidgetCostsReducer) => state.charts[dateTo],
    );

export const makeSelectorWidgetCostsIsLoading = ():
    OutputSelector<IRootReducer, boolean, (state: IWidgetCostsReducer) => boolean> =>
    createSelector(
        selectWidgetCosts,
        (state: IWidgetCostsReducer) => state.isLoading,
    );

export const makeSelectorWidgetCostsCurrentDateTo = ():
    OutputSelector<IRootReducer, string, (state: IWidgetCostsReducer) => string> =>
    createSelector(
        selectWidgetCosts,
        (state: IWidgetCostsReducer) => state.currentDateTo,
    );

export const makeSelectorWidgetCostsStatus = ():
    OutputSelector<IRootReducer, EWidgetStatus, (state: IWidgetCostsReducer) => EWidgetStatus> =>
    createSelector(
        selectWidgetCosts,
        (state: IWidgetCostsReducer) => state.error
            ? EWidgetStatus.ERROR
            : Object.keys(state.charts).length
            && state.charts[state.currentDateTo]
            && Object.entries(state.charts[state.currentDateTo].chart)
                .filter((entry: [string, number | undefined]) => entry[1] && entry[1] > 0).length
                ? EWidgetStatus.SUCCESS
                : EWidgetStatus.EMPTY,
    );
